import React, { useState } from 'react';
import jsonp from 'jsonp';
import { classNames } from 'react-extras';
import { validate } from 'email-validator';
import { CheckArrow } from 'components/Icons/CheckArrow';

// Change Mailchimp endpoint's `/post` to `/post-json` or Mailchimp returns an error
const endpoint = (process.env.GATSBY_MAILCHIMP_ENDPOINT || '').replace(/\/post/g, '/post-json');

type MailchimpSubscribeProps = {
    placeholder: string;
    cta: string;
    id: string;
};

const MailchimpSubscribe = (props: MailchimpSubscribeProps) => {
    const [email, setEmail] = useState<string>('');
    const [subscribed, setSubscribed] = useState<boolean>(false);
    const [error, setError] = useState<string | null>(null);

    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setEmail(event.target.value);
    };

    const handleSubmit = () => {
        if (subscribed) {
            return;
        }

        if (!validate(email)) {
            setError('Invalid email address');
            return;
        }

        const url = `${endpoint}&EMAIL=${encodeURIComponent(email)}`;

        jsonp(url, { param: 'c' }, (err: Error) => {
            if (err) {
                setError(err.message);
            } else {
                setSubscribed(true);
                setError(null);
            }
        });
    };

    return (
        <div
            className={classNames('MailchimpSubscribe FormElement', {
                'is-invalid': error,
            })}
        >
            <div className="InputGroup u-clickable">
                <input
                    id={props.id}
                    className="Input Input--hasAfter"
                    name="email"
                    type="email"
                    placeholder={props.placeholder}
                    value={email}
                    onChange={handleChange}
                    data-testid="emailInput"
                />
                <div
                    className={classNames('InputGroup-after', {
                        'is-active': subscribed,
                    })}
                    onClick={handleSubmit}
                    data-testid="submitButton"
                >
                    <div className="InputGroup-text">{props.cta}</div>
                    {subscribed && (
                        <div className="InputGroup-icon" data-testid="checkmark">
                            <CheckArrow />
                        </div>
                    )}
                </div>
            </div>
            {error && (
                <div className="FormElement-help" data-testid="errorMessage">
                    {error}
                </div>
            )}
        </div>
    );
};

export { MailchimpSubscribe, MailchimpSubscribeProps };
